<template>
  <div>
    <el-tabs v-model="qdtab" style="margin-left: 40px; margin-right: 40px;">
      <el-tab-pane label="讲师分类" name="teachertype">
        <el-row class="querypanel">
          <el-col :span="8">
            <div class="leftpanel">
              <div>讲师分类列表:</div>
              <el-tree
                class="filter-tree"
                show-checkbox
                node-key="id"
                ref="teacher_tree_list"
                :data="teacher_usergroupsdata"
                :props="teacher_defaultProps"
                :check-strictly = "true"
                default-expand-all
                :expand-on-click-node="false"
                :render-content="teacher_renderugcontext">
              </el-tree>
              <div class="desinfo"> *请先增加总分类，然后依次增加，注意总分类只能有一个，总分类下可以设置三级子分类。</div>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="rightpanel">
              <el-collapse v-model="teacher_activeNames" accordion >
                <el-collapse-item title="总分类" name="0">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="总分类">
                      <el-input v-model="teacher_gsbminfo"></el-input>
                    </el-form-item>
                    <el-form-item label="新增一级分类">
                      <el-input v-model="teacher_nameone" placeholder="仅新增一级分类时添加"></el-input>
                    </el-form-item>
                    <el-button @click="teacher_addzero">新增总分类</el-button>
                    <el-button @click="teacher_changezero">修改并保存</el-button>
                    <el-button @click="teacher_addone">新增一级子分类</el-button>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="一级分类" name="1">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前一级分类">
                      <el-input v-model="teacher_gsbmone"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="teacher_indexone"></el-input>
                    </el-form-item>
                    <el-form-item label="新增二级分类">
                      <el-input v-model="teacher_nametwo" placeholder="仅新增二级分类时添加"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="teacher_changeone">修改并保存</el-button>
                      <el-button @click="teacher_addtwo">新增二级分类</el-button>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="二级分类" name="2">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前二级分类">
                      <el-input v-model="teacher_gsbmtwo"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="teacher_indextwo"></el-input>
                    </el-form-item>
                    <el-form-item label="新增三级分类">
                      <el-input v-model="teacher_namethree" placeholder="仅新增三级分类添加"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="teacher_changetwo">修改并保存</el-button>
                      <el-button @click="teacher_addthree">新增三级分类</el-button>
                    </el-form-item>
                    <div>

                    </div>
                  </el-form>
                </el-collapse-item>
                <el-collapse-item title="三级分类" name="3">
                  <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                    <el-form-item label="当前三级分类">
                      <el-input v-model="teacher_gsbmthree"></el-input>
                    </el-form-item>
                    <el-form-item label="当前分类次序">
                      <el-input v-model="teacher_indexthree"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="teacher_changethree">修改并保存</el-button>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="讲师信息" name="teacherinfo">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" label-position="left" >
                <el-form-item label="讲师名称">
                  <el-input v-model="teacher_name" placeholder="请输入讲师的关键字"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form ref="form"  label-width="100px" style="margin-left: 20px" label-position="left" >
                <el-form-item label="讲师分类">
                  <el-select v-model="teacher_type" filterable placeholder="请选择讲师类别" height="120px">
                    <el-option
                      v-for="item in teacher_type_list"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_teacher">查找讲师</el-button>
              <el-button @click="add_newteacher">添加新讲师</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_teacher"
            ref="multipleTable">
            <el-table-column
              prop="id.Int64"
              label="讲师编号">
            </el-table-column>
            <el-table-column
              prop="name.String"
              width="180px"
              label="讲师名">
            </el-table-column>
            <el-table-column
              label="头像">
              <template slot-scope="scope">
                <div v-if="scope.row.portrait.Valid">
                  <img :src="scope.row.portrait.String" class="avatarimg3">
                </div>
                <div v-else>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone.String"
              label="联系方式">
            </el-table-column>
            <el-table-column
              prop="addtime.String"
              label="添加时间">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑讲师信息" placement="top-start">
                  <i class="fa fa-edit fa-lg opicon curpointer" v-on:click="edit_teacher(scope.$index, data_teacher)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除讲师" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_teacher(scope.$index, data_teacher)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="讲师信息" :visible.sync="vis_teacher_edit">
      <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
        <el-form-item label="选择会员">
          <el-input  v-model="ed_ma_member" placeholder="请选择关注用户">
            <el-button slot="append" icon="el-icon-search" @click="ev_sel_user"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="ed_teacher_contact" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="上传讲师头像" class="yyzz_upload">
          <el-upload
            class="avatar-uploader"
            multiple
            drag
            action=""
            :headers="uploadHeaders"
            :show-file-list="true"
            :http-request="fnUploadRequest"
            :on-success="OnJSTXResourceSuccess">
            <img v-if="ifportraitok" :src="portraiturl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="头像地址">
          <el-input v-model="ed_teacher_txaddress" placeholder="请输入头像地址"></el-input>
        </el-form-item>
        <el-form-item label="讲师名称">
          <el-input  v-model="ed_teacher_name" placeholder="请输入讲师名称"></el-input>
        </el-form-item>
        <el-form-item label="所属分类">
          <el-select v-model="ed_teacher_type" filterable placeholder="请选择讲师分类" height="120px">
            <el-option
              v-for="item in teacher_type_list"
              :key="item.id.Int64"
              :label="item.name.String"
              :value="item.id.Int64">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="讲师昵称">
          <el-input v-model="ed_teacher_nickname" placeholder="请输入讲师昵称"></el-input>
        </el-form-item>
        <el-form-item label="讲师文字简介">
          <el-input v-model="ed_teacher_jj" placeholder="请输入讲师文字简介"></el-input>
        </el-form-item>
        <!--- >
        <el-form-item label="上传身份证正面" class="yyzz_upload">
          <el-upload
            class="avatar-uploader"
            drag
            action=""
            :headers="uploadHeaders"
            :show-file-list="true"
            :http-request="fnUploadRequest"
            :on-success="OnIdCardZResourceSuccess">
            <img v-if="idcardzurlok" :src="idcardzurl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传身份证反面" class="yyzz_upload">
          <el-upload
            class="avatar-uploader"
            drag
            action=""
            :headers="uploadHeaders"
            :show-file-list="true"
            :http-request="fnUploadRequest"
            :on-success="OnIdCardFResourceSuccess">
            <img v-if="idcardfurlok" :src="idcardfurl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        --->
        <el-form-item label="讲师图文简介:" >
          <quill-editor
            v-model="descontext"
            ref="myQuillEditor"
            :options="editorOption"
            @change="onEditorChange($event)"
          >
          </quill-editor>
        </el-form-item>
        <el-form-item >
          <el-button style="margin-top:20px;" class="gibasebtn" @click="save_teacher">保存讲师</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="select_uppathtitle" :visible.sync="vis_upfilepanel">
      <el-row class="showpcinfo">
        <el-col :span="12">
          <el-form  label-width="120px">
            <el-form-item label="上传资料" class="yyzz_upload">
              <el-upload
                class="avatar-uploader"
                multiple
                drag
                action=""
                :on-success="fnUploadSuccess"
                :headers="uploadHeaders"
                :show-file-list="true"
                :http-request="fnUploadRequest"
                :limit="files">
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="上传说明" name="1">
              <div>1、您可以上传任何类型的资料。</div>
              <div>2、上传前一定要看好上传的路径！</div>
              <div>3、上传时，上传文件下方会有上传进度。</div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="用户选择" :visible.sync="vis_sel_user">
      <el-table
        stripe
        :data="data_member"
        highlight-current-row
        @current-change="sel_member_change"
        ref="multipleTable">
        <el-table-column
          prop="usernick.String"
          width = "200px"
          label="会员昵称">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
              <img :src="scope.row.userimg.String" class="avatarimg">
            </div>
            <div v-else>
              {{scope.row.userimg.String}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="电话号码">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Utils from '../../util/utils'
import '../../../static/css/my.css'
import global_ from '../../store/modules/ossparams.vue'
import * as Quill from 'quill'
import Video from '../../util/video'
import {quillRedefine} from 'vue-quill-editor-upload'
import {quillEditor} from 'vue-quill-editor'
Vue.config.productionTip = false
// 注册 vue-kikindeditor plugin
Quill.register(Video, true)
Vue.prototype.$http = axios
var OSS = require('ali-oss')
var that
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{'header': 1}, {'header': 2}],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{ script: 'sub' }, { script: 'super' }],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'size': ['small', false, 'large', 'huge']}],
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  [{'color': []}, {'background': []}],
  [{'font': []}],
  [{'align': []}],
  ['link', 'image', 'video'],
  ['clean']
]
export default {
  components: {quillEditor, quillRedefine},
  name: 'TeacherMana',
  beforeCreate: function () {
    that = this
    console.log('开始创建')
  },
  data () {
    return {
      teacher_usergroupsdata: [],
      khid: '',
      qdtab: 'teacherinfo',
      userdata: [],
      data_member: [],
      ed_ma_member: '',
      vis_sel_user: false,
      teacher_activeNames: [],
      teacher_selectnode: [],
      loading: false,
      teacher_gsbminfo: '',
      teacher_gsbmone: '',
      teacher_gsbmtwo: '',
      teacher_gsbmthree: '',
      teacher_nameone: '',
      teacher_nametwo: '',
      teacher_namethree: '',
      teacher_indexone: '',
      teacher_indextwo: '',
      teacher_indexthree: '',
      teacher_treereccount: 0,
      teacher_defaultProps: {
        children: 'Children',
        label: 'name'
      },
      teacher_name: '',
      data_teacher: [],
      teacher_type_list: [],
      ed_teacher_name: '',
      ed_teacher_type: '',
      ifportraitok: '',
      portraiturl: '',
      data_des: [],
      editorOption: {},
      ed_teacher_contact: '',
      activeName: '1',
      ed_teacher_jj: '',
      ed_teacher_nickname: '',
      ed_teacher_txaddress: '',
      idcardzurlok: false,
      idcardzurl: '',
      idcardfurlok: false,
      idcardfurl: '',
      descontext: '',
      teacher_type: '',
      vis_teacher_edit: false,
      selectpath: 'dfsd/teacher/', /// 上传路径
      selectteacher: '',
      ifedit: false,
      vis_upfilepanel: false,
      select_uppathtitle: '',
      upfiletype: '',
      uploadHeaders: { /// 上传参数头
        authorization: ''
      },
      files: 50
    }
  },
  created: function () {
    this.editorOption =
      {
        uploadConfig: {
          methods: 'POST',
          res: (respnse) => {
            console.log(respnse)
            return respnse.info
          }
        },
        methods: 'POST',
        size: 5100,
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
        // input点击事件  formData是提交的表单实体
        change: (formData) => {
        },
        // 设置请求头 xhr: 异步请求， formData: 表单对象
        header: (xhr, formData) => {
          // xhr.setRequestHeader('myHeader','myValue');
          // formData.append('token', '1234')
        },
        // start: function (){}
        start: () => {
        },
        end: () => {
        },
        success: () => {
          console.log('上传成功')
        },
        error: () => {
        },
        placeholder: '请在此输入内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                that.vis_upfilepanel = true
                that.select_uppathtitle = '上传图片'
                that.upfiletype = 'image'
              },
              'video': function (value) {
                that.vis_upfilepanel = true
                that.select_uppathtitle = '上传视频'
                that.upfiletype = 'video'
              }
            }
          }
        }
      }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/gttt',
        method: 'post',
        data: {
          cusid: parseInt(v),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.teacher_usergroupsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/qtt',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by id desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            localStorage.setItem('teacherinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.teacher_type_list = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    querymember () {
      var qstr = ' openid is not null'
      that.$http({
        url: 'https://api.sqnetsoft.cn/member/gbuw',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.data_member = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    ev_sel_user () {
      that.vis_sel_user = true
      that.$options.methods.querymember()
    },
    sel_member_change (val) {
      this.sel_user = val
      console.log(this.sel_user)
      this.vis_sel_user = false
      this.ed_ma_member = this.sel_user.usernick.String
      this.ifportraitok = true
      this.portraiturl = this.sel_user.userimg.String
      this.ed_teacher_txaddress = this.sel_user.userimg.String
      this.ed_teacher_nickname = this.sel_user.usernick.String
      this.ed_teacher_name = this.sel_user.usernick.String
    },
    onEditorChange: function (val) {
      window.console.log(val)
    },
    teacher_renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o gtopicon" on-click={ () => this.teacher_edit(node, data)}> </i>
            <i class="fa fa-trash-o gtopicon" on-click={ () => this.teacher_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    teacher_edit (node, data) {
      console.log(node)
      console.log(data)
      this.teacher_selectnode = data
      this.teacher_activeNames = [data.level.toString()]
      switch (data.level) {
        case 0: {
          that.teacher_gsbminfo = data.name
          break
        }
        case 1: {
          that.teacher_gsbmone = data.name
          that.teacher_indexone = data.sortindex
          break
        }
        case 2: {
          that.teacher_gsbmtwo = data.name
          that.teacher_indextwo = data.sortindex
          break
        }
        case 3: {
          that.teacher_gsbmthree = data.name
          that.teacher_indexthree = data.sortindex
          break
        }
      }
    },
    teacher_remove (node, data) {
      console.log(node)
      console.log(data)
      var idlist = []
      if (data.haschild === 0) {
        idlist.push(data.id)
      } else {
        idlist.push(data.id)
        var cnode = data.Children
        for (var index in cnode) {
          console.log(cnode[index])
          idlist.push(cnode[index].id)
          if (cnode[index].haschild === 0) {
          } else {
            var cinode = cnode[index].Children
            for (var i in cinode) {
              idlist.push(cinode[i].id)
              if (cinode[i].haschild === 0) {
              } else {
                var ciinode = cinode[i].Children
                for (var j in ciinode.Children) {
                  idlist.push(ciinode.Children[j].id)
                  if (cinode[i].haschild === 0) {
                  } else {
                    for (var k in ciinode.Children) {
                      idlist.push(ciinode.Children[k].id)
                    }
                  }
                }
              }
            }
          }
        }
      }
      var idstr = 'id in (' + idlist + ')'
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/dtt',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/teacher/gttt',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  that.teacher_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_changezero () {
      console.log(this.teacher_selectnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/aautt',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.teacher_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.teacher_gsbminfo, Valid: true},
          level: parseInt(this.teacher_selectnode.level),
          haschild: parseInt(this.teacher_selectnode.haschild),
          parentid: parseInt(-1)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.teacher_usergroupsdata = JSON.parse(res.data.data)
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_addzero () {
      if (that.teacher_treereccount <= 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/teacher/aautt',
          method: 'post',
          data: {
            cusid: parseInt(that.khid),
            name: {String: that.teacher_gsbminfo, Valid: true},
            level: parseInt(0),
            haschild: parseInt(0),
            parentid: parseInt(-1)
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/teacher/gttt',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    that.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'error',
          message: '只能保留一个总类!'
        })
      }
    },
    teacher_changeone () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/aautt',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.teacher_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.teacher_gsbmone, Valid: true},
          level: parseInt(this.teacher_selectnode.level),
          haschild: parseInt(this.teacher_selectnode.haschild),
          parentid: parseInt(this.teacher_selectnode.parentid),
          sortindex: parseInt(this.teacher_indexone)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.teacher_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_changetwo () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/aautt',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.teacher_selectnode.id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.teacher_gsbmtwo, Valid: true},
          level: parseInt(this.teacher_selectnode.level),
          haschild: parseInt(that.teacher_selectnode.haschild),
          parentid: parseInt(that.teacher_selectnode.parentid),
          sortindex: parseInt(this.teacher_indextwo)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.teacher_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_changethree () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/aautt',
        method: 'post',
        data: {
          id: {Int64: parseInt(that.teacher_selectnode.id), Valid: true},
          cusid: parseInt(that.khid),
          name: {String: that.teacher_gsbmthree, Valid: true},
          level: parseInt(that.teacher_selectnode.level),
          haschild: parseInt(that.teacher_selectnode.haschild),
          parentid: parseInt(that.teacher_selectnode.parentid),
          sortindex: parseInt(this.teacher_indexthree)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.teacher_usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_addone () {
      console.log(this.teacher_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.teacher_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.teacher_gsbminfo, Valid: true},
        level: parseInt(this.teacher_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.teacher_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.teacher_nameone, Valid: true},
        level: parseInt(this.teacher_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.teacher_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/paautt',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.teacher_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_addtwo () {
      console.log(this.teacher_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.teacher_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.teacher_gsbmone, Valid: true},
        level: parseInt(this.teacher_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.teacher_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.teacher_nametwo, Valid: true},
        level: parseInt(this.teacher_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.teacher_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/paautt',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.teacher_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    teacher_addthree () {
      console.log(this.teacher_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.teacher_selectnode.id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.teacher_gsbmtwo, Valid: true},
        level: parseInt(this.teacher_selectnode.level),
        haschild: parseInt(1),
        parentid: parseInt(this.teacher_selectnode.parentid),
        sortindex: parseInt(1)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.teacher_namethree, Valid: true},
        level: parseInt(this.teacher_selectnode.level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.teacher_selectnode.id),
        sortindex: parseInt(1)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/paautt',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/teacher/gttt',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.teacher_usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_teacher: function () {
      console.log('查询讲师')
      var qstr = 'cusid =' + that.khid
      if (that.teacher_name !== null && that.teacher_name !== '') {
        qstr = qstr + " and name like '%" + that.teacher_name + "%' "
      }
      if (that.teacher_type !== null && that.teacher_type !== '') {
        qstr = qstr + ' and find_in_set(' + that.teacher_type + ', owntypes)'
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/qti',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sortinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            localStorage.setItem('teacherinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_teacher = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    add_newteacher: function () {
      console.log('增加新讲师')
      this.vis_teacher_edit = true
      this.ifedit = false
      this.ed_teacher_name = ''
      this.ed_teacher_nickname = ''
      this.ed_teacher_type = ''
      this.ed_teacher_contact = ''
      this.idcardzurlok = false
      this.idcardzurl = ''
      this.idcardfurlok = false
      this.idcardfurl = ''
      this.ifportraitok = false
      this.ed_teacher_txaddress = ''
      this.portraiturl = ''
      this.ed_teacher_jj = ''
      this.descontext = ''
      this.ifedit = false
    },
    edit_teacher: function (index, data) {
      console.log(data[index])
      this.selectteacher = data[index]
      this.vis_teacher_edit = true
      this.ed_teacher_name = this.selectteacher.name.String
      this.ed_teacher_nickname = this.selectteacher.nickname.String
      this.ed_teacher_type = parseInt(this.selectteacher.owntypes.String)
      this.ed_teacher_contact = this.selectteacher.phone.String
      if (this.selectteacher.idnozurl.Valid) {
        this.idcardzurlok = true
        this.idcardzurl = this.selectteacher.idnozurl.String
      }
      if (this.selectteacher.idnofurl.Valid) {
        this.idcardfurlok = true
        this.idcardfurl = this.selectteacher.idnofurl.String
      }
      if (this.selectteacher.portrait.Valid) {
        this.ifportraitok = true
        this.ed_teacher_txaddress = this.selectteacher.portrait.String
        this.portraiturl = this.selectteacher.portrait.String
      }
      this.ifedit = true
      this.ed_teacher_jj = this.selectteacher.context.String
      this.descontext = this.selectteacher.tdes.String
    },
    del_teacher: function (index, data) {
      console.log(data[index])
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/dti',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    save_teacher: function () {
      console.log('保存讲师')
      console.log(this.ed_teacher_name)
      console.log(this.ed_teacher_type)
      console.log(this.ed_teacher_contact)
      console.log(this.ed_teacher_txaddress)
      console.log(this.ed_teacher_nickname)
      let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var adddata
      if (this.ifedit) {
        adddata = {
          id: {Int64: parseInt(this.selectteacher.id.Int64), Valid: true},
          name: {String: this.ed_teacher_name, Valid: true},
          nickname: {String: this.ed_teacher_nickname, Valid: true},
          owntypes: {String: this.ed_teacher_type.toString(), Valid: true},
          portrait: {String: this.ed_teacher_txaddress, Valid: true},
          sex: {Int64: parseInt(0), Valid: true},
          age: {Int64: parseInt(0), Valid: true},
          idnozurl: {String: '', Valid: true},
          idnofurl: {String: '', Valid: true},
          phone: {String: this.ed_teacher_contact, Valid: true},
          context: {String: this.ed_teacher_jj, Valid: true},
          tdes: {String: this.descontext, Valid: true},
          addtime: {String: addtime, Valid: true},
          openid: {String: this.sel_user.openid, Valid: true},
          cusid: parseInt(this.khid)
        }
      } else {
        adddata = {
          name: {String: this.ed_teacher_name, Valid: true},
          nickname: {String: this.ed_teacher_nickname, Valid: true},
          owntypes: {String: this.ed_teacher_type.toString(), Valid: true},
          portrait: {String: this.ed_teacher_txaddress, Valid: true},
          sex: {Int64: parseInt(0), Valid: true},
          age: {Int64: parseInt(0), Valid: true},
          idnozurl: {String: '', Valid: true},
          idnofurl: {String: '', Valid: true},
          phone: {String: this.ed_teacher_contact, Valid: true},
          context: {String: this.ed_teacher_jj, Valid: true},
          tdes: {String: this.descontext, Valid: true},
          addtime: {String: addtime, Valid: true},
          openid: {String: this.sel_user.openid, Valid: true},
          cusid: parseInt(this.khid)
        }
      }

      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/aauti',
        method: 'post',
        data: adddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.vis_teacher_edit = false
            that.$options.methods.query_teacher()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    onContentChange: function (val) {
      this.descontext = val
    },
    async OnJSTXResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.ed_teacher_txaddress = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        this.ifportraitok = true
        this.portraiturl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    async OnIdCardZResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.idcardzurlok = true
        this.idcardzurl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    async OnIdCardFResourceSuccess (res, file, fileList) {
      if (res.res.status === 200) {
        this.idcardfurlok = true
        this.idcardfurl = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
      }
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },

    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: global_.ACCESSKEYID,
          accessKeySecret: global_.ACCESSKEYSECRET,
          bucket: global_.BUCTKE
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = global_.Teacher + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (res, file, fileList) {
      console.log(res)
      if (res.res.status === 200) {
        var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        console.log(uppath)
        console.log(this.upfiletype)
        if (this.upfiletype === 'image') {
          this.descontext = this.descontext + '<p><img src="' + uppath + '"></p>'
        } else {
          this.descontext = this.descontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
        }
        console.log(this.descontext)
      }
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/teacher/TeacherMana.vue